import React , { useState, useEffect, useRef }from 'react'
import { Spin } from 'antd';
import { gapi } from 'gapi-script';
import {ListDocuments} from '../SelectSource/ListDocuments';
import { useCookies } from 'react-cookie';
import GoogleDriveImage from '../assets/images/google-drive.png';
import spinner from '../assets/images/spinner.gif';
import linkBreak from '../assets/images/LinkBreak.png';
import galogo from '../assets/images/ga-logo.png';
import backImage from '../assets/images/back.png';
import folderImage from '../assets/images/folder.png';
import playIcon from '../assets/images/playicon.png';
import buttonImage from '../assets/images/new-signIn.png';
import './App.css';
import { SelectSource } from '../SelectSource/SelectSource';

// Array of API discovery doc URLs for APIs
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];

// Authorization scopes required by the API multiple scopes can be
// included, separated by spaces.
const SCOPES = 'https://www.googleapis.com/auth/drive.readonly';

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const API_KEY = process.env.REACT_APP_API_KEY;

export const SelectSourcePopup = (props:  any) => {

    const { getDriveFileData, screenSize, onDragStart, onDragEnd} = props;

  const [cookies, setCookie, removeCookie] = useCookies();
  const [listDocumentsVisible, setListDocumentsVisibility] = useState(false);
  const [rootId, setRootId] = useState('');
  const [isLoadingGoogleDriveApi, setIsLoadingGoogleDriveApi] = useState(false);
  const [isFetchingGoogleDriveFiles, setIsFetchingGoogleDriveFiles] = useState(false);
  const [signedInUser, setSignedInUser] = useState();
  const [gInstance, setGInstance] = useState();
  const [token, setToken] = useState({});


  /**
   * Print files.
   */
  const setParent = async () => {
    setIsFetchingGoogleDriveFiles(true);
    const searchTerm = "'root' in parents";
    const response = await gapi.client.drive.files.list({
      pageSize: 1,
      fields:
        'nextPageToken, files(id, name, mimeType, modifiedTime, thumbnailLink, webViewLink, exportLinks, parents)',
      q: searchTerm,
    });

    const res = JSON.parse(response.body);
    if (Array.isArray(res.files) && res.files.length > 0) {
      setRootId(res.files[0].parents[0]);
    }
  };

  /**
   *  Sign in the user upon button click.
   */
  const handleAuthClick = (event: any) => {
    gapi.auth2.getAuthInstance().signIn();
  };

  function handleCredentialResponse(res: any){
    console.log(res)
  }

  useEffect(() => {
    const script = document.createElement('script');
      script.src = 'https://apis.google.com/js/platform.js'
      // script.async = true;
      // script.defer = true
      document.body.appendChild(script);
      script.onload = function(){
        window.onload = function(){
        /*global google*/
        //@ts-ignore
        google.accounts.id.initialize({
          client_id: CLIENT_ID,
          callback: handleCredentialResponse
        });

        const parent = document.getElementById('btn-click');
        //@ts-ignore
        google.accounts.id.renderButton(parent, {theme: "filled_blue"});
      }
      }
  })

  /**
   *  Called when the signed in status changes, to update the UI
   *  appropriately. After a sign-in, the API is called.
   */

  useEffect(() => {
    if (!gInstance && cookies.gUser) {
      setTimeout(() => {
        if(screenSize){
          return (<SelectSource />)
        }
        handleClientLoad();
      },500)
      
    }
  }, [rootId, signedInUser, gInstance]);

  const updateSigninStatus = (isSignedIn: any) => {
    if (isSignedIn || cookies.user) {
      // Set the signed in user
      if (cookies.user) {
        setSignedInUser(cookies.user);
        setParent();
      } else {
        setToken(gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse());
        setSignedInUser(gapi.auth2.getAuthInstance().currentUser.le.wt);
        window.localStorage.setItem('gUser', JSON.stringify(gapi.auth2.getAuthInstance().currentUser.le.wt))
        document.cookie = `gUser=${window.localStorage.getItem('gUser')}; SameSite=None; Secure`;
        setIsLoadingGoogleDriveApi(false);
        setParent();
      }
    } else {
      // prompt user to sign in
      //@ts-ignore
      handleAuthClick();
    }
  };

  /**
   *  Sign out the user upon button click.
   */
  const handleSignOutClick = (event: any) => {
    const time = new Date()
    window.localStorage.setItem('gUser', '')
    document.cookie = `gUser=${window.localStorage.getItem('gUser')}; SameSite=None; Secure`
    //@ts-ignore
    setSignedInUser(false);
    setListDocumentsVisibility(false);
    window.location.reload()
    //gapi.auth2.getAuthInstance();
  };

    /**
   *  Initializes the API client library and sets up sign-in state
   *  listeners.
   */
    const initClient = () => {
        setIsLoadingGoogleDriveApi(true);
        gapi.client
          .init({
            apiKey: API_KEY,
            clientId: CLIENT_ID,
            discoveryDocs: DISCOVERY_DOCS,
            scope: SCOPES,
            access_type: 'offline',
          })
          .then(
            function () {
              // Listen for sign-in state changes.
              gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);
    
              // Handle the initial sign-in state.
              updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
              setGInstance(gapi.client);
            },
            function (error: any) {
                console.log(error)
            }
          );
      };

    const handleClientLoad = () => {
      const expression = /(Mac)/i;

if (expression.test(navigator.platform)) {
  gapi.load('client', initClient);
} else {
  gapi.load('client:auth2', initClient);
}
    };

    const showDocuments = () => {
        setListDocumentsVisibility(true);
      };

    const onClose = () => {
        setListDocumentsVisibility(false);
    };

  return (
    <div className='googleDriveApp'>
      {signedInUser || cookies.gUser ? (
        <ListDocuments
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          visible={listDocumentsVisible}
          onClose={onClose}
          documents={[]}
          directories={[]}
          rootId={rootId}
          token={token}
          signedInUser={signedInUser}
          onSignOut={handleSignOutClick}
          isLoading={isFetchingGoogleDriveFiles}
          gapiClient={gInstance}
          cookies={cookies}
          spinner={spinner}
          linkBreak={linkBreak}
          galogo={galogo} 
          backImage={backImage} 
          folderImage={folderImage}
          playIcon={playIcon}
          getDriveFileData={getDriveFileData}
        />
      ) : (
        <div>
          <Spin spinning={isLoadingGoogleDriveApi} style={{ width: '100%' }}>
            <div className="googleDriveApp-source-container" style={{ paddingTop: '35%' }}>
              <div className="content-container">
                <span className="content, googleDriveApp-get-started">Get started by connecting your account</span>
              </div>
              <div className="icon-container" style={{ paddingTop: '40px' }}>
                <div className="icon icon-success">
                  <img height="100px" width="100px" src={GoogleDriveImage} />
                </div>
              </div>
              <div className={'content-container'} style={{ paddingTop: '50px' }} id='btn-click' onClick={() => handleClientLoad()}>
                <img src={buttonImage} style={{ cursor: 'pointer', height: '50px' }} alt='button_image' />
              </div>
            </div>
          </Spin>
        </div>
      )}
    </div>
  )
}